/* Limavia Linterna Frontal LED — landing behaviour (prefix: lfl-)
   No custom cart logic. The theme's <product-form> + product-form.js
   own Add to Cart; Kaching Bundles injects the offers. This file only
   drives the gallery, accordions, inline video and the sticky bar.
   Accordions + video use EVENT DELEGATION on document so they keep
   working after the Theme Editor re-renders a section. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    if (root.__lflInit) return;
    root.__lflInit = true;
    var track = root.querySelector('.lfl-gallery__track');
    var slides = root.querySelectorAll('.lfl-gallery__slide');
    var dots = root.querySelectorAll('.lfl-dot');
    var thumbs = root.querySelectorAll('.lfl-thumb');
    var prev = root.querySelector('.lfl-arrow--prev');
    var next = root.querySelector('.lfl-arrow--next');
    var count = slides.length;
    var idx = 0;
    if (count <= 1) { root.classList.add('lfl-gallery--single'); }

    function go(i) {
      idx = (i + count) % count;
      if (track) track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === idx);
      for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('is-active', t === idx);
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    for (var d = 0; d < dots.length; d++) (function (i) { dots[i].addEventListener('click', function () { go(i); }); })(d);
    for (var t = 0; t < thumbs.length; t++) (function (i) { thumbs[i].addEventListener('click', function () { go(i); }); })(t);

    /* swipe (mobile) */
    var main = root.querySelector('.lfl-gallery__main');
    if (main && count > 1) {
      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    }
    go(0);
  }
  function initGalleries(scope) {
    var g = (scope || document).querySelectorAll('.lfl-gallery');
    for (var i = 0; i < g.length; i++) initGallery(g[i]);
  }

  /* ---------------- Accordions + video (delegated) ---------------- */
  function toggleAccordion(btn) {
    var item = btn.closest('[data-lfl-acc-item]');
    if (!item) return;
    var panel = item.querySelector('[data-lfl-acc-panel]');
    var open = item.classList.toggle('is-open');
    if (panel) { if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', ''); }
    var sign = btn.querySelector('[data-lfl-sign]');
    if (sign && sign.getAttribute('data-lfl-sign') === 'plusminus') sign.textContent = open ? '−' : '+';
  }
  function playCardVideo(playBtn) {
    var card = playBtn.parentNode;
    var vid = card.querySelector('video');
    var poster = card.querySelector('.lfl-gallery__poster');
    if (!vid) return;
    playBtn.style.display = 'none';
    if (poster) poster.style.display = 'none';
    vid.style.display = 'block';
    vid.muted = false;
    vid.setAttribute('controls', '');
    try { vid.play(); } catch (e) {}
  }
  /* one document-level listener → survives section re-renders, never double-binds */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lfl-acc__btn, .lfl-facc__btn, .lfl-faq-btn');
    if (btn) { toggleAccordion(btn); return; }
    var play = e.target.closest && e.target.closest('.lfl-vid-card__play, .lfl-gallery__playbtn, .lfl-included-play');
    if (play) { playCardVideo(play); return; }
  });

  /* videos buffer with the page (Phase 6.2) */
  function primeVideos() {
    var vids = document.querySelectorAll('.lfl video[preload="auto"]');
    for (var i = 0; i < vids.length; i++) { try { vids[i].load(); } catch (e) {} }
  }

  /* ---------------- Sticky mobile bar ---------------- */
  function initSticky() {
    var bar = document.querySelector('.lfl-sticky');
    if (!bar || bar.__lflInit) return;
    bar.__lflInit = true;
    var offers = document.getElementById('lfl-offers');
    var buyArea = document.querySelector('.lfl-hero__buy') || offers;
    var priceOut = bar.querySelector('.lfl-sticky__price');
    var btn = bar.querySelector('.lfl-sticky__btn');
    var footer = document.querySelector('footer') || document.querySelector('.footer');

    if (btn && offers) {
      btn.addEventListener('click', function () {
        var y = offers.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    }

    /* mirror whatever price the buy area / bundle app renders — never recalc */
    var moneyRe = /(\d[\d.\s]*[.,]\d{2}\s*(?:€|EUR)|\€\s?\d[\d.,\s]*|\d[\d.,]*\s?€)/i;
    function syncPrice() {
      if (!priceOut || !buyArea) return;
      var best = '';
      var nodes = buyArea.querySelectorAll('*');
      for (var i = nodes.length - 1; i >= 0; i--) {
        var el = nodes[i];
        if (el.children.length) continue; /* leaf nodes only */
        var txt = (el.textContent || '').trim();
        if (txt && moneyRe.test(txt) && txt.length < 24) { best = txt; break; }
      }
      if (best && priceOut.textContent !== best) priceOut.textContent = best;
    }
    if (buyArea && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { syncPrice(); });
      mo.observe(buyArea, { childList: true, subtree: true, characterData: true });
    }
    syncPrice();

    var shown = false;
    function onScroll() {
      var half = (document.documentElement.scrollHeight - window.innerHeight) * 0.45;
      var buyGone = true;
      if (offers) buyGone = offers.getBoundingClientRect().bottom < 0;
      var footerIn = false;
      if (footer) footerIn = footer.getBoundingClientRect().top < window.innerHeight - 20;
      var want = (window.scrollY > half || buyGone) && !footerIn;
      if (want !== shown) { shown = want; bar.classList.toggle('is-visible', want); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll(); /* hidden on load */
  }

  ready(function () {
    initGalleries(document);
    primeVideos();
    initSticky();
  });

  /* Theme Editor: re-init galleries when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    initGalleries(e.target);
    primeVideos();
  });
})();
